import { Icon } from '#app/components/ui/icon.tsx'
/* This example requires Tailwind CSS v2.0+ */
const navigation = {
	support: [
		{ name: 'Pricing', href: '#' },
		{ name: 'Documentation', href: '#' },
		{ name: 'Guides', href: '#' },
		{ name: 'API Status', href: '#' },
	],
	papelea: [
		{ name: 'Acerca de Papelea', href: '/sobre-papelea' },
		{ name: 'Contacta con nosotros', href: '/contacto' },
		{ name: 'Aviso Legal y Política de Privacidad', href: '/legal' },
	],
	countries: [
		{ name: 'España', href: '/es/administraciones' },
		{ name: 'México', href: '/mx/administraciones' },
		{ name: 'Argentina', href: '/ar/administraciones' },
	],
	social: [
		{
			name: 'Linkedin',
			href: 'https://es.linkedin.com/company/papelea',
			icon: 'linkedin-logo',
		},
		{
			name: 'Twitter',
			href: 'https://x.com/papelea',
			icon: 'twitter-logo',
		},
	],
}

export default function Footer() {
	return (
		<footer className="bg-amber-100" aria-labelledby="footer-heading">
			{/* <h2 id="footer-heading" className="sr-only">
				Footer
			</h2> */}
			<div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
				<div className="xl:grid xl:grid-cols-3 xl:gap-8">
					<div className="space-y-8 xl:col-span-1">
						<img className="h-10" src="/img/logo.png" alt="Company name" />
						<p className="text-base text-gray-500">
							Papelea no pertenece a ninguna administración. Nuestro objetivo es
							facilitarte la información sobre tus gestiones para que pierdas el
							menor tiempo posible.
						</p>
						<div className="flex space-x-6">
							{navigation.social.map((item) => (
								<a
									key={item.name}
									href={item.href}
									className="text-gray-400 hover:text-gray-500"
								>
									<span className="sr-only">{item.name}</span>
									<Icon name={item.icon} aria-hidden="true" size="md" />
								</a>
							))}
						</div>
					</div>
					<div className="mt-12 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0">
						<div className="md:grid md:grid-cols-2 md:gap-8">
							<div className="mt-12 md:mt-0"></div>
						</div>
						<div className="md:grid md:grid-cols-2 md:gap-8">
							<div>
								<h3 className="text-sm font-extrabold tracking-wider text-gray-900 uppercase">
									Sobre Papelea
								</h3>
								<ul className="mt-4 space-y-4">
									{navigation.papelea.map((item) => (
										<li key={item.name}>
											<a
												href={item.href}
												className="text-base text-gray-500 hover:text-gray-900"
											>
												{item.name}
											</a>
										</li>
									))}
								</ul>
							</div>
							<div className="mt-12 md:mt-0">
								<h3 className="text-sm font-extrabold tracking-wider text-gray-900 uppercase">
									Países
								</h3>
								<ul className="mt-4 space-y-4">
									{navigation.countries.map((item) => (
										<li key={item.name}>
											<a
												href={item.href}
												className="text-base text-gray-500 hover:text-gray-900"
											>
												{item.name}
											</a>
										</li>
									))}
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className="mt-12 border-t border-gray-300 pt-8">
					<p className="text-base text-gray-400 xl:text-center">
						&copy; {new Date().getFullYear()} Papelea Online. Todos los derechos
						reservados.
					</p>
				</div>
			</div>
		</footer>
	)
}
